"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledWrapper = _styledComponents2.default.div.withConfig({
  displayName: "Paginator__StyledWrapper",
  componentId: "sc-1asf71c-0"
})(["display:flex;justify-content:flex-end;height:32px;"]);

const StyledButton = _styledComponents2.default.button.withConfig({
  displayName: "Paginator__StyledButton",
  componentId: "sc-1asf71c-1"
})(["width:32px;height:32px;background:none;outline:0;border:1px solid ", ";border-right:0;color:", ";cursor:pointer;:last-of-type{border-right:1px solid ", ";padding-left:", "px;}:hover{opacity:0.7;transition:0.2s all;}"], _styles.colors.dropDownWindowBorder, props => props.disabled ? _styles.colors.datePickerBorder : _styles.colors.accentFocusInput, _styles.colors.dropDownWindowBorder, (0, _styles.calcPadding)(3));

const StyledCurrentPage = _styledComponents2.default.div.withConfig({
  displayName: "Paginator__StyledCurrentPage",
  componentId: "sc-1asf71c-2"
})(["font-size:13px;min-width:60px;padding:", "px 0;text-align:center;border:1px solid ", ";border-right:0;color:", ";font-family:", ";-webkit-font-smoothing:antialiased;"], (0, _styles.calcPadding)(2), _styles.colors.dropDownWindowBorder, _styles.colors.svgFill, _styles.fontFamily1);

const StyledChevron = _styledComponents2.default.span.withConfig({
  displayName: "Paginator__StyledChevron",
  componentId: "sc-1asf71c-3"
})(["position:absolute;width:5px;height:5px;background:transparent;border-top:1.6px solid ", ";border-right:1.6px solid ", ";transform:", ";margin-left:", ";display:", ";:last-child{margin-left:", ";}:first-child{margin-left:", ";}"], _styles.colors.accentFocusInput, _styles.colors.accentFocusInput, props => props.left ? "translate3d(0,-50%,0) rotate(-135deg)" : "translate3d(0,-50%,0) rotate(45deg)", props => props.left && props.single ? "-3px !important" : null, props => props.left || props.single ? null : "block", props => props.left ? "-5px" : null, props => props.left ? null : "-5px");

const Paginator = ({
  onClickLeft,
  onClickLeftMost,
  onClickRight,
  onClickRightMost,
  currentPage,
  totalPages
}) => _react2.default.createElement(
  StyledWrapper,
  null,
  _react2.default.createElement(
    StyledButton,
    { onClick: onClickLeftMost, disabled: currentPage === 1 },
    _react2.default.createElement(StyledChevron, { left: true }),
    _react2.default.createElement(StyledChevron, { left: true })
  ),
  _react2.default.createElement(
    StyledButton,
    { onClick: onClickLeft, disabled: currentPage === 1 },
    _react2.default.createElement(StyledChevron, { left: true, single: true })
  ),
  _react2.default.createElement(
    StyledCurrentPage,
    null,
    `${currentPage} of ${totalPages}`
  ),
  _react2.default.createElement(
    StyledButton,
    { onClick: onClickRight, disabled: currentPage === totalPages },
    _react2.default.createElement(StyledChevron, { right: true, single: true })
  ),
  _react2.default.createElement(
    StyledButton,
    {
      onClick: onClickRightMost,
      disabled: currentPage === totalPages
    },
    _react2.default.createElement(StyledChevron, { right: true }),
    _react2.default.createElement(StyledChevron, { right: true })
  )
);

Paginator.propTypes = {
  totalPages: _propTypes2.default.number,
  currentPage: _propTypes2.default.number,
  onClickLeft: _propTypes2.default.func,
  onClickRight: _propTypes2.default.func,
  onClickLeftMost: _propTypes2.default.func,
  onClickRightMost: _propTypes2.default.func
};

exports.default = Paginator;